import React from "react";
import Marker from "./Marker";

export default function MapView({
  map,
  markers,
  markerScale,
  showDevMenu,
  showCoords,
  mapRefs,
  onMarkerChange,
  onMarkerRemove,
  onMarkerEdit,
  showMarkerIds,
}) {
  if (!map) return null;
  return (
    <div
      ref={(el) => {
        mapRefs.current[map.key] = el;
      }}
      className="map-anim map-container relative border-2 border-ewave-border"
      style={{
        scrollSnapAlign: "center",
        width: "min(100vw, 100vh)",
        height: "auto",
        maxWidth: "100vw",
        maxHeight: "calc(100vh - 32px)",
        minWidth: "auto",
        minHeight: "auto",
        aspectRatio: "1/1",
        borderRadius: 20,
        background: "#23244d",
        margin: 0,
        position: "absolute",
        top: "50%",
        left: "calc(50% + 160px)",
        transform: "translate(-50%, -50%)",
        opacity: 1,
        zIndex: 100,
        paddingTop: 0,
        overflow: "visible",
        display: "block",
        flex: "auto",
        flexShrink: "auto",
      }}
    >
      <img
        id={`main-map-img-${map.key}`}
        src={map.img}
        alt={map.name}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          borderRadius: 16,
          userSelect: "none",
          pointerEvents: "none",
          zIndex: 1,
          position: "relative",
          top: "auto",
          left: "auto",
          maxWidth: "100%",
          maxHeight: "100%",
          display: "block",
        }}
        className="block"
        loading={"eager"}
        crossOrigin="anonymous"
      />
      {/* Contest glow elipsa */}
      {/* Uklonjeno na zahtjev, više se ne koristi vizualni efekt elipse za contest markere */}
      {/* Real markers */}
      {markers
        .filter((m) => m.map === map.key)
        .map((marker) => (
          <React.Fragment key={marker.id}>
            <Marker
              marker={marker}
              onChange={onMarkerChange}
              onRemove={onMarkerRemove}
              onEdit={onMarkerEdit}
              scale={markerScale}
              showDev={showDevMenu}
              showCoords={showCoords}
              mapContainerRef={{ current: mapRefs.current[map.key] }}
              showMarkerIds={showMarkerIds}
            />
            {showDevMenu && showMarkerIds && (
              <div
                style={{
                  position: "absolute",
                  left: `${marker.x * 100}%`,
                  top: `${marker.y * 100 - 7}%`,
                  transform: "translate(-50%, -100%)",
                  background: "#23244d",
                  color: "#e0aaff",
                  fontSize: "0.78rem",
                  padding: "2px 8px",
                  borderRadius: 6,
                  fontWeight: 700,
                  zIndex: 100,
                  pointerEvents: "none",
                  boxShadow: "0 2px 8px #e0aaff55",
                  whiteSpace: "nowrap",
                  opacity: 0.95,
                  marginBottom: "2px",
                }}
              >
                {marker.id}
              </div>
            )}
          </React.Fragment>
        ))}
      <div
        style={{
          position: "absolute",
          top: 8,
          left: 16,
          zIndex: 10,
          color: "#fff",
          fontWeight: 700,
          fontSize: 22,
          textShadow: "0 2px 8px #000a",
          display: "block",
        }}
      >
        {map.name}
      </div>
    </div>
  );
}
